// src/models/assessments.enum.ts
var AssessmentQuestionTypeEnum = /* @__PURE__ */ ((AssessmentQuestionTypeEnum2) => {
  AssessmentQuestionTypeEnum2["BusinessOwner"] = "BusinessOwner";
  AssessmentQuestionTypeEnum2["BusinessPurpose"] = "BusinessPurpose";
  AssessmentQuestionTypeEnum2["BusinessUnit"] = "BusinessUnit";
  AssessmentQuestionTypeEnum2["DropdownCustomField"] = "DropdownCustomField";
  AssessmentQuestionTypeEnum2["TextCustomField"] = "TextCustomField";
  AssessmentQuestionTypeEnum2["DataFlow"] = "DataFlow";
  AssessmentQuestionTypeEnum2["DataRole"] = "DataRole";
  AssessmentQuestionTypeEnum2["DataSources"] = "DataSources";
  AssessmentQuestionTypeEnum2["DataSubjects"] = "DataSubjects";
  AssessmentQuestionTypeEnum2["DataTypes"] = "DataTypes";
  AssessmentQuestionTypeEnum2["Datepicker"] = "DatePicker";
  AssessmentQuestionTypeEnum2["DpiaNeeded"] = "DpiaNeeded";
  AssessmentQuestionTypeEnum2["Dropdown"] = "Dropdown";
  AssessmentQuestionTypeEnum2["File"] = "File";
  AssessmentQuestionTypeEnum2["LegalBasis"] = "LegalBasis";
  AssessmentQuestionTypeEnum2["LinkedAssessment"] = "LinkedAssessment";
  AssessmentQuestionTypeEnum2["PartiesWithAccess"] = "PartiesWithAccess";
  AssessmentQuestionTypeEnum2["Risks"] = "Risks";
  AssessmentQuestionTypeEnum2["ShortAnswer"] = "ShortAnswer";
  AssessmentQuestionTypeEnum2["Text"] = "Text";
  AssessmentQuestionTypeEnum2["TextBlock"] = "TextBlock";
  AssessmentQuestionTypeEnum2["Textarea"] = "Textarea";
  AssessmentQuestionTypeEnum2["TransferMechanism"] = "TransferMechanism";
  AssessmentQuestionTypeEnum2["Group"] = "group";
  AssessmentQuestionTypeEnum2["NewSection"] = "new-section";
  AssessmentQuestionTypeEnum2["CustomComponent"] = "custom-component";
  return AssessmentQuestionTypeEnum2;
})(AssessmentQuestionTypeEnum || {});
var AssessmentStatusEnum = /* @__PURE__ */ ((AssessmentStatusEnum2) => {
  AssessmentStatusEnum2["Completed"] = "Completed";
  AssessmentStatusEnum2["Draft"] = "Draft";
  return AssessmentStatusEnum2;
})(AssessmentStatusEnum || {});
var AssessmentTemplateEnum = /* @__PURE__ */ ((AssessmentTemplateEnum2) => {
  AssessmentTemplateEnum2["AI"] = "AI";
  AssessmentTemplateEnum2["AI_EU"] = "AI-EU";
  AssessmentTemplateEnum2["AI_RISK_MODEL_DEVELOPER_FOCUSED"] = "AI-Risk-Model-Developer-Focused";
  AssessmentTemplateEnum2["COPPA"] = "COPPA";
  AssessmentTemplateEnum2["DORA_ICT_THIRD_PARTY_CRITICALITY"] = "DORA-ICT-Third-Party-Criticality";
  AssessmentTemplateEnum2["DPIA"] = "DPIA";
  AssessmentTemplateEnum2["Empty"] = "Empty";
  AssessmentTemplateEnum2["HIPAA"] = "HIPAA";
  AssessmentTemplateEnum2["LIA"] = "LIA";
  AssessmentTemplateEnum2["NIST_CSF_RISK"] = "NIST-CSF-Risk";
  AssessmentTemplateEnum2["PA"] = "PA";
  AssessmentTemplateEnum2["PIA"] = "PIA";
  AssessmentTemplateEnum2["ROI"] = "ROI";
  AssessmentTemplateEnum2["THIRD_PARTY_DPIA"] = "Third-Party-DPIA";
  AssessmentTemplateEnum2["TIA"] = "TIA";
  AssessmentTemplateEnum2["Vendor"] = "Vendor";
  return AssessmentTemplateEnum2;
})(AssessmentTemplateEnum || {});
var DataFlowNodeTypeEnum = /* @__PURE__ */ ((DataFlowNodeTypeEnum2) => {
  DataFlowNodeTypeEnum2["System"] = "System";
  DataFlowNodeTypeEnum2["CustomEntity"] = "CustomEntity";
  return DataFlowNodeTypeEnum2;
})(DataFlowNodeTypeEnum || {});
var ChipColorName = /* @__PURE__ */ ((ChipColorName2) => {
  ChipColorName2["Grey"] = "grey";
  ChipColorName2["Purple"] = "purple";
  ChipColorName2["Yellow"] = "yellow";
  ChipColorName2["Blue"] = "blue";
  ChipColorName2["Red"] = "red";
  ChipColorName2["Green"] = "green";
  ChipColorName2["LightPurple"] = "light-purple";
  ChipColorName2["LightPink"] = "light-pink";
  ChipColorName2["VeryLightBlue"] = "very-light-blue";
  ChipColorName2["Cyan"] = "cyan";
  return ChipColorName2;
})(ChipColorName || {});

// src/util.ts
function normalizeString(str) {
  return str?.toLowerCase()?.replace(/[^a-zA-Z]/g, "");
}
function cleanObject(obj) {
  return Object.fromEntries(
    Object.entries(obj).filter(([, value]) => Boolean(value))
  );
}
function camelCaseWithSpaces(value) {
  if (!value) return "";
  value = value.toLowerCase().trim();
  value = value.replace(/[-\s]/g, " ");
  const words = value.replace(/[^\w\s]/g, "").split(/\s+/);
  if (words.length < 2) return words.join("");
  const capitalizedWords = words.slice(1).map((word) => word.charAt(0).toUpperCase() + word.slice(1));
  return words[0] + capitalizedWords.join("");
}
var COLOR_OPACITY_SUFFIX = "40";
var MINE_CHIP = /* @__PURE__ */ new Map([
  ["purple" /* Purple */, { backgroundColor: "var(--mine-purple-light-2)", textColor: "var(--mine-purple-dark)" }],
  ["blue" /* Blue */, { backgroundColor: "var(--mine-blue-2)", textColor: "var(--mine-blue-3)" }],
  ["grey" /* Grey */, { backgroundColor: "var(--mine-grey-light-2)", textColor: "var(--mine-grey-3)" }],
  ["yellow" /* Yellow */, { backgroundColor: "var(--mine-light-yellow)", textColor: "var(--mine-dark-yellow-3)" }],
  ["red" /* Red */, { backgroundColor: "var(--mine-red-light-4)", textColor: "var(--mine-red-2)" }],
  ["green" /* Green */, { backgroundColor: "var(--mine-green-2)", textColor: "var(--mine-green-3)" }],
  ["light-purple" /* LightPurple */, { backgroundColor: "var(--mine-purple-light-6)", textColor: "var(--mine-purple-dark)" }],
  ["light-pink" /* LightPink */, { backgroundColor: "var(--mine-pink-light)", textColor: "var(--mine-pink-dark)" }],
  ["very-light-blue" /* VeryLightBlue */, { backgroundColor: "var(--mine-blue-very-light-2)", textColor: "var(--mine-dark-blue-2)" }],
  ["cyan" /* Cyan */, { backgroundColor: "var(--mine-blue-very-light-3)", textColor: "var(--mine-dark-blue-3)" }]
]);
function customEntityChipBackgroundColor(color) {
  if (color) {
    return color.startsWith("var(--") ? color : color.endsWith(COLOR_OPACITY_SUFFIX) ? color : color + COLOR_OPACITY_SUFFIX;
  }
  return MINE_CHIP.get("grey" /* Grey */)?.backgroundColor ?? "var(--mine-grey-light-2)";
}

// ../node_modules/uuid/dist/esm-browser/regex.js
var regex_default = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i;

// ../node_modules/uuid/dist/esm-browser/validate.js
function validate(uuid) {
  return typeof uuid === "string" && regex_default.test(uuid);
}
var validate_default = validate;

// ../node_modules/uuid/dist/esm-browser/parse.js
function parse(uuid) {
  if (!validate_default(uuid)) {
    throw TypeError("Invalid UUID");
  }
  let v;
  return Uint8Array.of((v = parseInt(uuid.slice(0, 8), 16)) >>> 24, v >>> 16 & 255, v >>> 8 & 255, v & 255, (v = parseInt(uuid.slice(9, 13), 16)) >>> 8, v & 255, (v = parseInt(uuid.slice(14, 18), 16)) >>> 8, v & 255, (v = parseInt(uuid.slice(19, 23), 16)) >>> 8, v & 255, (v = parseInt(uuid.slice(24, 36), 16)) / 1099511627776 & 255, v / 4294967296 & 255, v >>> 24 & 255, v >>> 16 & 255, v >>> 8 & 255, v & 255);
}
var parse_default = parse;

// ../node_modules/uuid/dist/esm-browser/stringify.js
var byteToHex = [];
for (let i = 0; i < 256; ++i) {
  byteToHex.push((i + 256).toString(16).slice(1));
}
function unsafeStringify(arr, offset = 0) {
  return (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + "-" + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + "-" + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + "-" + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + "-" + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase();
}

// ../node_modules/uuid/dist/esm-browser/rng.js
var getRandomValues;
var rnds8 = new Uint8Array(16);
function rng() {
  if (!getRandomValues) {
    if (typeof crypto === "undefined" || !crypto.getRandomValues) {
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    getRandomValues = crypto.getRandomValues.bind(crypto);
  }
  return getRandomValues(rnds8);
}

// ../node_modules/uuid/dist/esm-browser/v35.js
function stringToBytes(str) {
  str = unescape(encodeURIComponent(str));
  const bytes = new Uint8Array(str.length);
  for (let i = 0; i < str.length; ++i) {
    bytes[i] = str.charCodeAt(i);
  }
  return bytes;
}
var DNS = "6ba7b810-9dad-11d1-80b4-00c04fd430c8";
var URL = "6ba7b811-9dad-11d1-80b4-00c04fd430c8";
function v35(version, hash, value, namespace, buf, offset) {
  const valueBytes = typeof value === "string" ? stringToBytes(value) : value;
  const namespaceBytes = typeof namespace === "string" ? parse_default(namespace) : namespace;
  if (typeof namespace === "string") {
    namespace = parse_default(namespace);
  }
  if (namespace?.length !== 16) {
    throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
  }
  let bytes = new Uint8Array(16 + valueBytes.length);
  bytes.set(namespaceBytes);
  bytes.set(valueBytes, namespaceBytes.length);
  bytes = hash(bytes);
  bytes[6] = bytes[6] & 15 | version;
  bytes[8] = bytes[8] & 63 | 128;
  if (buf) {
    offset = offset || 0;
    if (offset < 0 || offset + 16 > buf.length) {
      throw new RangeError(`UUID byte range ${offset}:${offset + 15} is out of buffer bounds`);
    }
    for (let i = 0; i < 16; ++i) {
      buf[offset + i] = bytes[i];
    }
    return buf;
  }
  return unsafeStringify(bytes);
}

// ../node_modules/uuid/dist/esm-browser/native.js
var randomUUID = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var native_default = { randomUUID };

// ../node_modules/uuid/dist/esm-browser/v4.js
function v4(options, buf, offset) {
  if (native_default.randomUUID && !buf && !options) {
    return native_default.randomUUID();
  }
  options = options || {};
  const rnds = options.random ?? options.rng?.() ?? rng();
  if (rnds.length < 16) {
    throw new Error("Random bytes length must be >= 16");
  }
  rnds[6] = rnds[6] & 15 | 64;
  rnds[8] = rnds[8] & 63 | 128;
  if (buf) {
    offset = offset || 0;
    if (offset < 0 || offset + 16 > buf.length) {
      throw new RangeError(`UUID byte range ${offset}:${offset + 15} is out of buffer bounds`);
    }
    for (let i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }
    return buf;
  }
  return unsafeStringify(rnds);
}
var v4_default = v4;

// ../node_modules/uuid/dist/esm-browser/sha1.js
function f(s, x, y, z) {
  switch (s) {
    case 0:
      return x & y ^ ~x & z;
    case 1:
      return x ^ y ^ z;
    case 2:
      return x & y ^ x & z ^ y & z;
    case 3:
      return x ^ y ^ z;
  }
}
function ROTL(x, n) {
  return x << n | x >>> 32 - n;
}
function sha1(bytes) {
  const K = [1518500249, 1859775393, 2400959708, 3395469782];
  const H = [1732584193, 4023233417, 2562383102, 271733878, 3285377520];
  const newBytes = new Uint8Array(bytes.length + 1);
  newBytes.set(bytes);
  newBytes[bytes.length] = 128;
  bytes = newBytes;
  const l = bytes.length / 4 + 2;
  const N = Math.ceil(l / 16);
  const M = new Array(N);
  for (let i = 0; i < N; ++i) {
    const arr = new Uint32Array(16);
    for (let j = 0; j < 16; ++j) {
      arr[j] = bytes[i * 64 + j * 4] << 24 | bytes[i * 64 + j * 4 + 1] << 16 | bytes[i * 64 + j * 4 + 2] << 8 | bytes[i * 64 + j * 4 + 3];
    }
    M[i] = arr;
  }
  M[N - 1][14] = (bytes.length - 1) * 8 / Math.pow(2, 32);
  M[N - 1][14] = Math.floor(M[N - 1][14]);
  M[N - 1][15] = (bytes.length - 1) * 8 & 4294967295;
  for (let i = 0; i < N; ++i) {
    const W = new Uint32Array(80);
    for (let t = 0; t < 16; ++t) {
      W[t] = M[i][t];
    }
    for (let t = 16; t < 80; ++t) {
      W[t] = ROTL(W[t - 3] ^ W[t - 8] ^ W[t - 14] ^ W[t - 16], 1);
    }
    let a = H[0];
    let b = H[1];
    let c = H[2];
    let d = H[3];
    let e = H[4];
    for (let t = 0; t < 80; ++t) {
      const s = Math.floor(t / 20);
      const T = ROTL(a, 5) + f(s, b, c, d) + e + K[s] + W[t] >>> 0;
      e = d;
      d = c;
      c = ROTL(b, 30) >>> 0;
      b = a;
      a = T;
    }
    H[0] = H[0] + a >>> 0;
    H[1] = H[1] + b >>> 0;
    H[2] = H[2] + c >>> 0;
    H[3] = H[3] + d >>> 0;
    H[4] = H[4] + e >>> 0;
  }
  return Uint8Array.of(H[0] >> 24, H[0] >> 16, H[0] >> 8, H[0], H[1] >> 24, H[1] >> 16, H[1] >> 8, H[1], H[2] >> 24, H[2] >> 16, H[2] >> 8, H[2], H[3] >> 24, H[3] >> 16, H[3] >> 8, H[3], H[4] >> 24, H[4] >> 16, H[4] >> 8, H[4]);
}
var sha1_default = sha1;

// ../node_modules/uuid/dist/esm-browser/v5.js
function v5(value, namespace, buf, offset) {
  return v35(80, sha1_default, value, namespace, buf, offset);
}
v5.DNS = DNS;
v5.URL = URL;
var v5_default = v5;

// src/uuid.ts
var NAMESPACE = "e6f8f5e7-4e75-4323-9c65-d91b8f2cdbb7";
function assessmentUuid(value) {
  if (!value) return "";
  return v5_default("" + value, NAMESPACE);
}
function generateControlUuid(control) {
  if (Object.prototype.hasOwnProperty.call(control, "layout")) {
    const ctrl2 = control;
    return `${ctrl2.formControlId ?? ctrl2.id}`;
  }
  const ctrl = control;
  return ctrl.id ?? assessmentUuid(`${ctrl.type}-${ctrl.name}`);
}
function generateSectionUuid(section) {
  if (Object.prototype.hasOwnProperty.call(section, "questions")) {
    const sec2 = section;
    return `${sec2.formControlId ?? sec2.id}`;
  }
  const sec = section;
  return sec.id ?? assessmentUuid(`${sec.type}-${sec.name}`);
}
function getSectionQuestions(section) {
  if (Object.prototype.hasOwnProperty.call(section, "controls")) {
    return section.controls ?? [];
  }
  if (section.questions) {
    return section.questions;
  }
  return [];
}
function generateSectionsUuid(sections) {
  return sections.map((section) => {
    const questions = getSectionQuestions(section);
    return {
      ...section,
      id: section.id ?? generateSectionUuid(section),
      controls: questions?.map((control) => {
        const controlId = Object.prototype.hasOwnProperty.call(control, "templateQuestionId") ? control.templateQuestionId : control.id;
        return {
          ...control,
          id: controlId ?? generateControlUuid(control)
        };
      })
    };
  });
}

// src/schema.ts
function isObjectWithKey(variable, key) {
  return typeof variable === "object" && variable !== null && Object.prototype.hasOwnProperty.call(variable, key);
}
function deepJsonParse(input) {
  let result = input;
  while (typeof result === "string") {
    try {
      result = JSON.parse(result);
    } catch {
      break;
    }
  }
  return result;
}
function parseSectionSchema(input) {
  const result = deepJsonParse(input);
  if (isObjectWithKey(result, "controls")) {
    return result.controls;
  }
  return result;
}

// src/question-mapper.ts
var CUSTOM_COMPONENT_TYPE = "custom-component";
function getQuestionTypeByValue(val) {
  return Object.values(AssessmentQuestionTypeEnum).find((value) => normalizeString(value) === normalizeString(val));
}
function getQuestionType(params) {
  if (!params) {
    return void 0;
  }
  const { type, name } = params;
  if (type === CUSTOM_COMPONENT_TYPE && name || name?.includes("--")) {
    const foundKey = Object.keys(AssessmentQuestionTypeEnum).find(
      (key) => normalizeString(AssessmentQuestionTypeEnum[key]) === normalizeString(name.split("--")[0])
    );
    return (foundKey ? AssessmentQuestionTypeEnum[foundKey] : void 0) ?? getQuestionTypeByValue(type);
  }
  return getQuestionTypeByValue(type);
}
function createLayoutObject(options) {
  return JSON.stringify(cleanObject(options));
}
function normalizeOptionLayout(layout) {
  if (!layout) {
    return layout;
  }
  if (typeof layout !== "string") {
    return JSON.stringify(layout);
  }
  try {
    let parsed = JSON.parse(layout);
    if (typeof parsed === "string") {
      try {
        parsed = JSON.parse(parsed);
      } catch {
      }
    }
    return JSON.stringify(parsed);
  } catch {
    return layout;
  }
}
function createDropdownOptions(options) {
  return options?.map((option) => ({
    id: option.id,
    label: option.label ?? option.value,
    layout: normalizeOptionLayout(option.layout),
    isSelected: option.isSelected ?? false
  }));
}
function createQuestionValue(question, type) {
  const value = question.value;
  const q = question;
  if (type === "TextCustomField" /* TextCustomField */) {
    return {
      customFieldId: value?.["customFieldId"] ?? q?.["customFieldId"],
      textValue: value?.["textValue"] ?? q?.["textValue"]
    };
  }
  if (type === "DropdownCustomField" /* DropdownCustomField */) {
    return {
      customFieldId: value?.["customFieldId"] ?? q?.["customFieldId"],
      options: createDropdownOptions(value?.["options"] ?? q?.["options"])
    };
  }
  if (type === "Dropdown" /* Dropdown */) {
    return createDropdownOptions(value?.["options"] ?? q?.["options"] ?? value);
  }
  return question.value;
}
function createQuestionRequest(question) {
  const q = question;
  const type = getQuestionType({ type: q["type"], name: q["name"] });
  const layout = createLayoutObject({
    disabled: q["disabled"],
    description: q["description"],
    multiple: q["multiple"],
    placeholder: q["placeholder"],
    required: q["required"],
    tooltip: q["tooltip"],
    validations: q["validations"]
  });
  return {
    // Mirror templateSectionId: coerce a possibly-numeric control id to a string so the BE's
    // strict System.Text.Json deserialiser accepts it. Controls with no id stay undefined (no mint).
    templateQuestionId: q["id"] != null ? String(q["id"]) : void 0,
    formControlId: v4_default(),
    label: q["label"],
    name: q["name"] ?? camelCaseWithSpaces(q["label"]),
    type,
    value: createQuestionValue(question, type),
    layout
  };
}

// src/section-mapper.ts
function getPageOrdinality(sections) {
  const sectionOrdinality = [];
  for (const section of sections) {
    if (section.formControlId) {
      sectionOrdinality.push(section.formControlId);
    }
  }
  return JSON.stringify({ sectionOrdinality });
}
function getSectionOrdinality(questions) {
  const questionOrdinality = [];
  for (const question of questions) {
    if (question.formControlId) {
      questionOrdinality.push(question.formControlId);
    }
  }
  return JSON.stringify({ questionOrdinality });
}

// src/logic-remap.ts
var LOGIC_ID_DELIMITER = "||";
function remapAssessmentLogic(logic, sectionIdMap, questionIdMap) {
  if (!logic) return logic;
  let parsed;
  try {
    parsed = JSON.parse(logic);
  } catch {
    return logic;
  }
  if (!parsed || typeof parsed !== "object") return logic;
  const remapKey = (key) => {
    if (!key) return null;
    if (key.includes(LOGIC_ID_DELIMITER)) {
      const [sec, ctrl] = key.split(LOGIC_ID_DELIMITER);
      const newSec2 = sectionIdMap.get(sec);
      const newCtrl = questionIdMap.get(ctrl);
      if (!newSec2 || !newCtrl) return null;
      return `${newSec2}${LOGIC_ID_DELIMITER}${newCtrl}`;
    }
    const newSec = sectionIdMap.get(key);
    return newSec ?? null;
  };
  const remapped = {};
  for (const origKey of Object.keys(parsed)) {
    const newKey = remapKey(origKey);
    if (!newKey) continue;
    const entry = parsed[origKey];
    if (entry?.conditions && Array.isArray(entry.conditions)) {
      entry.conditions = entry.conditions.map((cond) => {
        if (!cond?.questionId) return cond;
        const newRef = remapKey(String(cond.questionId));
        if (!newRef) return null;
        return { ...cond, questionId: newRef };
      }).filter(Boolean);
    }
    remapped[newKey] = entry;
  }
  return JSON.stringify(remapped);
}

// src/cms-template.ts
var CUSTOM_COMPONENT_TYPES = [
  "BusinessOwner" /* BusinessOwner */,
  "BusinessPurpose" /* BusinessPurpose */,
  "BusinessUnit" /* BusinessUnit */,
  "DataFlow" /* DataFlow */,
  "DataRole" /* DataRole */,
  "DataSources" /* DataSources */,
  "DataSubjects" /* DataSubjects */,
  "DataTypes" /* DataTypes */,
  "DatePicker" /* Datepicker */,
  "DpiaNeeded" /* DpiaNeeded */,
  "File" /* File */,
  "LegalBasis" /* LegalBasis */,
  "LinkedAssessment" /* LinkedAssessment */,
  "PartiesWithAccess" /* PartiesWithAccess */,
  "Risks" /* Risks */,
  "TextBlock" /* TextBlock */,
  "TransferMechanism" /* TransferMechanism */,
  "custom-component" /* CustomComponent */
];
function getCmsControlType(type) {
  const normalizedType = normalizeString(type);
  const customComponentTypes = CUSTOM_COMPONENT_TYPES.map((t) => normalizeString(t));
  if (customComponentTypes.includes(normalizedType)) {
    return "custom-component";
  }
  return normalizedType;
}
function getCmsControlName(name, type) {
  if (type === "textarea") return `richText--${v4_default()}`;
  if (type === "text") return `shortAnswer--${v4_default()}`;
  if (type === "dropdown") return `multipleChoice--${v4_default()}`;
  if (type === "file") return `fileUpload--${v4_default()}`;
  if (name === "assessments" || name === "stakeholders") return "linkedAssessment";
  return name;
}
function getControlOptions(options, type) {
  return type === "dropdown" ? options ?? [] : [];
}
function mapSchemaToCmsControl(control) {
  const controlType = getCmsControlType(control["type"]);
  const controlName = getCmsControlName(control["name"], controlType);
  const controlOptions = getControlOptions(control["options"], controlType);
  const { options, ...controlWithoutOptions } = control;
  const schema = {
    ...controlWithoutOptions,
    type: controlType,
    name: controlName
  };
  if (controlOptions?.length > 0) {
    schema.options = controlOptions;
  }
  return schema;
}
function stampCmsSchemaIds(sections) {
  return sections.map((section) => {
    const questions = getSectionQuestions(section);
    return {
      ...section,
      id: assessmentUuid(`${section.type}-${section.name}`),
      controls: questions?.map((control) => {
        const controlId = Object.prototype.hasOwnProperty.call(control, "templateQuestionId") ? control.templateQuestionId : void 0;
        return {
          ...control,
          id: controlId ?? generateControlUuid(control)
        };
      })
    };
  });
}
function buildCmsTemplate(template) {
  if (!template || !Array.isArray(template.sections)) {
    throw new Error("Missing template, or template sections are empty");
  }
  const mineOSSchema = [];
  template.sections.forEach((section) => {
    const controls = JSON.parse(section.schema ?? section.controls);
    mineOSSchema.push({
      id: section.id,
      type: section.type,
      name: section.name,
      label: section.label,
      controls: controls.map((control) => mapSchemaToCmsControl(control))
    });
  });
  return stampCmsSchemaIds(mineOSSchema);
}

// src/assessment-builder.ts
function resolveTemplateSectionId(section) {
  if (section.id == null) return void 0;
  const id = String(section.id);
  if (!/^\d+$/.test(id)) return id;
  return assessmentUuid(`${section.type ?? "group" /* Group */}-${section.name ?? camelCaseWithSpaces(section.label)}`);
}
function createBaseAssessmentRequest(name, agentId, systemId, type) {
  const request = {
    name,
    agentId,
    state: "Draft" /* Draft */
  };
  if (systemId) {
    request.vendorSpecificId = systemId;
  }
  const assessmentType = type && typeof type === "string" ? Object.keys(AssessmentTemplateEnum).find((key) => normalizeString(key) === normalizeString(type) || normalizeString(AssessmentTemplateEnum[key]) === normalizeString(type)) : type;
  request.type = assessmentType;
  return request;
}
function buildAssessmentRequest(template, ctx = {}) {
  const baseRequest = createBaseAssessmentRequest(
    ctx.name ?? "",
    template.agentId,
    ctx.system?.systemId ?? "",
    template.type
  );
  const orderedSections = [...template.sections].sort((a, b) => (a.ordinal ?? 0) - (b.ordinal ?? 0));
  const sections = orderedSections.map((section) => {
    const parsed = parseSectionSchema(section.schema);
    const controls = Array.isArray(parsed) ? parsed : [];
    const questions = controls.map((control) => createQuestionRequest(control));
    return {
      // A numeric section id is re-derived to the deterministic uuid the `logic` is keyed on
      // (and emitted as a string — the BE's TemplateSectionId column is `text` and its strict
      // System.Text.Json deserialiser rejects a raw number). See resolveTemplateSectionId.
      templateSectionId: resolveTemplateSectionId(section),
      formControlId: v4_default(),
      label: section.label,
      name: section.name ?? camelCaseWithSpaces(section.label),
      layout: getSectionOrdinality(questions),
      questions
    };
  });
  const request = {
    ...baseRequest,
    logic: template.logic,
    sections,
    tagIds: template.tags?.map((t) => t.id),
    templatePageId: template.id ?? void 0,
    layout: getPageOrdinality(sections)
  };
  return request;
}
export {
  AssessmentQuestionTypeEnum,
  AssessmentStatusEnum,
  AssessmentTemplateEnum,
  CUSTOM_COMPONENT_TYPE,
  ChipColorName,
  DataFlowNodeTypeEnum,
  LOGIC_ID_DELIMITER,
  NAMESPACE,
  assessmentUuid,
  buildAssessmentRequest,
  buildCmsTemplate,
  camelCaseWithSpaces,
  cleanObject,
  createBaseAssessmentRequest,
  createDropdownOptions,
  createLayoutObject,
  createQuestionRequest,
  createQuestionValue,
  customEntityChipBackgroundColor,
  deepJsonParse,
  generateControlUuid,
  generateSectionUuid,
  generateSectionsUuid,
  getCmsControlName,
  getCmsControlType,
  getControlOptions,
  getPageOrdinality,
  getQuestionType,
  getQuestionTypeByValue,
  getSectionOrdinality,
  getSectionQuestions,
  isObjectWithKey,
  mapSchemaToCmsControl,
  normalizeOptionLayout,
  normalizeString,
  parseSectionSchema,
  remapAssessmentLogic
};
